/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import FormyField from "../field";
import FormyComponent from "../index";
export default class FormyDateComponent extends Component {
  get id() {
    return this.args.parent instanceof FormyField ? this.args.parent.id : undefined;
  }
  get errorId() {
    return this.args.parent instanceof FormyField ? this.args.parent.errorId : undefined;
  }
  get formy() {
    if (this.args.parent instanceof FormyComponent) return this.args.parent;
    return this.args.parent.args.formy;
  }
  get changeset() {
    return this.formy.args.changeset;
  }
  get key() {
    return this.args.parent instanceof FormyField ? this.args.parent.args.key : this.args.key;
  }
}